import { LanguageProvider, ConfigurationRegistry, PreferenceConfiguration } from "./preferenceConfigurationConst";
import { PreferenceController } from "./preferenceController";
import { UIService } from "./preferenceUISvc";

let preferenceModule = angular
  .module("sdApp.preference", ["sdApp.config", "sdServicesModule"])
  .constant("preferenceConfigurationRegistry", new ConfigurationRegistry())
  .constant("preferenceLanguageProvider", new LanguageProvider())
  .service("preferenceUIService", UIService)
  .controller("preferenceController", PreferenceController)
  .directive("sdCustomPreference", [
    "$compile",
    ($compile: ng.ICompileService) => {
      return {
        scope: {},
        restrict: "E",
        replace: true,
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: any) => {
          element.html(attrs.html);
          $compile(element.contents())(scope);
        }
      };
    }
  ])
  .config(PreferenceConfiguration);
export default preferenceModule;
